import { router } from '@inertiajs/svelte'
import { isInertiaUrl } from 'shared/javascripts/util/inertia_paths'

// Visits to pages outside config/inertia_paths.json become full page loads before they are sent, rather than
// rendering a page only to have InertiaBoundary::Middleware discard it.
export function leaveInertiaForOtherPages(
  leave: (url: string) => void = (url) => window.location.assign(url),
): () => void {
  return router.on('before', (event) => {
    const { visit } = event.detail

    // Returning false cancels the visit: router.on turns it into preventDefault() on the cancelable event.
    if (visit.method !== 'get' || isInertiaUrl(visit.url) || isCurrentPage(visit.url)) {
      return true
    } else if (visit.prefetch) {
      // `before` also fires for prefetches. There is nothing to load in full for those, so they are only dropped.
      return false
    } else {
      leave(visit.url.href)
      return false
    }
  })
}

function isCurrentPage(url: URL): boolean {
  const { origin, pathname, search } = window.location
  return url.origin === origin && url.pathname === pathname && url.search === search
}
